/* EZ · Carrito nuevo (17-oct-2026) — botón «Agregar» de «Suma al Más x Menos» (snippets/ez-carrito-sugeridos).
   Escucha en document (el carrito se re-renderiza entero y los script metidos por innerHTML no corren).
   Agrega con /cart/add.js pidiendo las mismas secciones que product-form.js de Dawn y llama a
   renderContents del cart-drawer; después avisa cartUpdate, igual que Dawn.
   Sin barras invertidas (LECCIONES C3). */
(function () {
  if (window.ezCarritoListo) return;
  window.ezCarritoListo = true;

  /* Dawn escucha 'change' en <cart-drawer-items> y lo trata como cambio de cantidad:
     el selector de talla de las tarjetas no debe llegar hasta ahí. */
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var card = t.closest('[data-ezs-card]');
    if (!card) return;
    e.stopPropagation();
    mostrarError(card, '');
  }, true);

  function raiz() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function mostrarError(card, texto) {
    var err = card ? card.querySelector('.ezs-error') : null;
    if (!err) return;
    err.textContent = texto;
    err.hidden = !texto;
  }

  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest ? e.target.closest('[data-ezs-agregar]') : null;
    if (!btn) return;
    e.preventDefault();
    if (btn.getAttribute('aria-busy') === 'true') return;

    var card = btn.closest('[data-ezs-card]');
    var sel = card ? card.querySelector('[data-ezs-variante]') : null;
    var id = sel ? parseInt(sel.value, 10) : 0;
    if (!id) {
      var pide = sel && sel.options.length && sel.options[0].text.indexOf('color') > -1 ? 'Elige el color primero.' : 'Elige la talla primero.';
      mostrarError(card, pide);
      if (sel) sel.focus();
      return;
    }

    mostrarError(card, '');
    var texto = btn.textContent;
    btn.setAttribute('aria-busy', 'true');
    btn.textContent = 'Agregando…';

    var drawer = document.querySelector('cart-drawer');
    var cuerpo = { items: [{ id: id, quantity: 1 }] };
    if (drawer && typeof drawer.getSectionsToRender === 'function') {
      cuerpo.sections = drawer.getSectionsToRender().map(function (s) { return s.id; });
      cuerpo.sections_url = window.location.pathname;
    }

    fetch(raiz() + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(cuerpo)
    })
      .then(function (r) {
        return r.json().then(function (json) {
          if (!r.ok || json.status) throw json;
          return json;
        });
      })
      .then(function (json) {
        try { if (typeof window.clarity === 'function') window.clarity('event', 'ez_carrito_sugerido'); } catch (x) {}
        var linea = json.items && json.items[0] ? json.items[0] : json;
        if (drawer && json.sections && typeof drawer.renderContents === 'function') {
          linea.sections = json.sections;
          drawer.renderContents(linea);
        } else {
          window.location.href = raiz() + 'cart';
          return;
        }
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'ez-carrito', productVariantId: id, cartData: linea });
        }
      })
      .catch(function (err) {
        btn.removeAttribute('aria-busy');
        btn.textContent = texto;
        var agotado = err && (err.status === 422 || err.status === '422');
        mostrarError(card, agotado ? 'Se agotó esa opción. Elige otra.' : 'No se pudo agregar. Prueba de nuevo.');
      });
  });
})();
